import { render, staticRenderFns } from "./SalarieList.vue?vue&type=template&id=593ad78c&scoped=true"
import script from "./SalarieList.vue?vue&type=script&lang=js"
export * from "./SalarieList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ad78c",
  null
  
)

export default component.exports